(function($, undefined) {
	
	'use strict';
	var mapCtn;
	var gmaps;
	var formValidator;
	var form = $('.contactForm-Container');

	var submitContactForm = function(captchaResponse) {
		formValidator.validateForm(form);

		if (!form.hasClass('has-error') && captchaResponse) {
			form.addClass('disabled');

			var name = $('.field1', form).val();
			var fieldName1 = $('.fieldName1', form).val();
			var email = $('input[name=email]', form).val();
			var phone = $('.field2', form).val();
			var fieldName2 = $('.fieldName2', form).val();
			var message = $('textarea[name=message]', form).val();
			var subject = $('input[name=subject]', form).val();
			
			var url = '/action/contactUs';
			var data = {
				"email": email,
				"subject": subject,
				"content": message,
				"fieldName1": fieldName1,
				"field1": name,
				"fieldName2": fieldName2,
				"field2": phone,
				"captcha": captchaResponse,
				"count": 3,
				"ajax": true
			};

			$.ajax({
				url: url,
				data: data,
				method: 'POST',
				success: function(response) {
					if(response.trim() === 'success') {
						resetForm(form);
						form.find('.success-msg').slideDown();
						form.find('.error-msg').slideUp();
					} else {
						form.find('.success-msg').slideUp();
						form.find('.error-msg').slideDown();
					}

					form.removeClass('disabled');
				},
				error: function(xhr, status, err) {
					// console.log(status + " " + err);
					form.find('.success-msg').slideUp();
					form.find('.error-msg').slideDown();

					form.removeClass('disabled');
				}
			});
		}
        else{
			grecaptcha.reset();
            form.find('.error-msg').slideDown();            
        }
	};

	function resetForm(form) {
		form[0].reset();
		form.find('.form-input').each(function() {
			var t = $(this);
			t.removeClass('success').removeClass('error');
		});
		form.find('textarea').each(function() {
			$(this).val('');
		});
	}

	var init = function () {
		formValidator = Fw.component.models().form;
		gmaps = Fw.modules.models().gmaps;
		mapCtn = $('#contact-map');

		gmaps.initSingleMap(mapCtn);
	};

	var contactUtil = Fw.component.export('contactUtil', {
		init: init,
		submitContactForm: submitContactForm
	});
	
	$(window).on('load', function () {
		init();
	});
	
})(jQuery);
